export default __webpack_public_path__ + "static/media/phone-call.c1b235f0.png";